import { render, staticRenderFns } from "./viewPoints.vue?vue&type=template&id=1755008b"
import script from "./viewPoints.vue?vue&type=script&lang=js"
export * from "./viewPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports